import { apiGet } from '@/store/api';
import { usePortcallStore } from '@/store/portcallStore';

export async function getCrewChangeTasks({ callId, clientId }: { callId: string | number; clientId: string | number }) {
  const result = await apiGet(`crewchange/call/${callId}/tasks/${clientId}`);
  usePortcallStore().setCrewChangeTasks(result);
  return result;
}
